import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { ListViewExternalFilteringService } from '../list-view-external-filtering.service';
import {
  LIST_VIEW_EXTERNAL_FILTERING_DIALOG_ID,
  ListViewExternalFilteringDialogComponent,
} from './list-view-external-filtering-dialog.component';

@Injectable({ providedIn: 'root' })
export class ListViewExternalFilteringDialogService extends AbstractDialogService<
  ListViewExternalFilteringService,
  boolean | undefined,
  typeof ListViewExternalFilteringDialogComponent
> {
  override readonly id = LIST_VIEW_EXTERNAL_FILTERING_DIALOG_ID;
  protected override readonly component = ListViewExternalFilteringDialogComponent;

  override readonly options: DialogOptions = {
    cssClass: 'filtering-dialog 1auto-height action-sheet-on-mobile',
    showBackdrop: true,
    backdropDismiss: true,
    handle: true,
  };

  open(filteringService: ListViewExternalFilteringService) {
    return super.openDialog({
      options: {
        componentProps: {
          filteringService,
        },
      },
    });
  }
}
